class StoreDeviceType {
  constructor (
    id = undefined,
    name
  ) {
    this.id = id
    this.name = name
  }

  toNormalizedRESTModel () {
    return ({
      // id is read-only
      name: this.name
    })
  }

  static FromNormalizedRESTModel ({
    id,
    name
  }) {
    return new StoreDeviceType(
      id,
      name
    )
  }

  toJSON () {
    return {
      id: this.id,
      name: this.name
    }
  }

  static FromJSON ({
    id,
    name
  }) {
    return new StoreDeviceType(
      id,
      name
    )
  }
}

/** Device types from db are identified through device type names inside the client app. **/
// TODO: sync these names with the db periodically
StoreDeviceType.DEVICE_TYPE_NAMES = {
  ANDROID_PHONE: 'Android mobile',
  IPHONE: 'iOS mobile',
  TRACKER: 'GPS tracker/beacon'
}

/** Legacy `type_device` / `device_types.id` values (1 = Android, 2 = iOS, 3 = tracker). */
StoreDeviceType.DEVICE_TYPE_IDS = {
  ANDROID_PHONE: 1,
  IPHONE: 2,
  TRACKER: 3
}

StoreDeviceType.MOBILE_PLATFORMS = {
  ANDROID: 'android',
  IPHONE: 'iphone'
}

/**
 * Resolve mobile platform for grid icons from type id (preferred) or type name.
 * @param device {{ typeId?: number|string, type?: { id?: number|string, name?: string } }}
 * @returns {'android'|'iphone'|null}
 */
StoreDeviceType.resolveMobilePlatform = device => {
  if (!device) {
    return null
  }

  const typeId = Number(device.typeId ?? device.type?.id)
  if (typeId === StoreDeviceType.DEVICE_TYPE_IDS.ANDROID_PHONE) {
    return StoreDeviceType.MOBILE_PLATFORMS.ANDROID
  }
  if (typeId === StoreDeviceType.DEVICE_TYPE_IDS.IPHONE) {
    return StoreDeviceType.MOBILE_PLATFORMS.IPHONE
  }

  const typeName = (device.type?.name || '').trim()
  if (typeName === StoreDeviceType.DEVICE_TYPE_NAMES.ANDROID_PHONE) {
    return StoreDeviceType.MOBILE_PLATFORMS.ANDROID
  }
  if (typeName === StoreDeviceType.DEVICE_TYPE_NAMES.IPHONE) {
    return StoreDeviceType.MOBILE_PLATFORMS.IPHONE
  }

  const normalizedName = typeName.toLowerCase()
  if (normalizedName.includes('android')) {
    return StoreDeviceType.MOBILE_PLATFORMS.ANDROID
  }
  if (normalizedName.includes('ios') || normalizedName.includes('iphone')) {
    return StoreDeviceType.MOBILE_PLATFORMS.IPHONE
  }

  return null
}

export default StoreDeviceType
